import { alpha, Stack, Theme } from '@mui/material';
import { useEmbeddingContextVisible } from 'hooks/useEmbeddingContext';

export default function TopControlsWrapper({ children }: { children: any }) {
    const isTopControlVisible = useEmbeddingContextVisible('header');

    if (!isTopControlVisible) {
        return null;
    }

    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{
                px: 2,
                py: 1,
                borderBottom: '1px solid',
                borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
                backgroundColor: 'background.default',
                zIndex: 2,
            }}
        >
            {children}
        </Stack>
    );
}
